
import Vue from 'vue';

import { defaultAddr } from 'frontend/addresses/info';

export default {
	resetOrder(state)
	{
		state.order = {
			shippingAddress: { ...defaultAddr },
			billingAddress: { ...defaultAddr },
			pickUpInStore: false,
		};
	},

	updateOrder(state, fields)
	{
		state.order = { ...state.order, ...fields };
	},

	updateSummary(state, summary)
	{
		state.summary = { ...summary };
	}
}